/*
Knob Pulls
  --diameter <float> | inches
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'
import { diameter } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...hardwareFormFields,
  diameter(false)
]
